import { generateDefaultColors, isKey, ticksFormatter, } from "../Components/HelpersFce";
import { extend } from "@hydrosoft/utils";
export const getDataList = (datasets) => {
    const data = datasets.getData();
    const dataList = {
        datasets: [],
        labels: [],
    };
    const dSetDefBgColors = generateDefaultColors(Object.keys(data).length, 0.5); //	default bacgkground color
    const dSetDefBorderColors = generateDefaultColors(Object.keys(data).length, 1); //	default border color
    dataList.labels = data[0].x; //	Set labels
    Object.keys(data).forEach((k) => {
        if (isKey(data, k)) {
            const dataset = data[k];
            const defaults = {
                backgroundColor: dSetDefBgColors[k],
                borderColor: dSetDefBorderColors[k],
            };
            const colors = extend(defaults, {
                backgroundColor: dataset.color,
                borderColor: dataset.borderColor === undefined
                    ? dataset.color
                    : dataset.borderColor,
            });
            const fillColorStat = dataset.fill !== undefined
                ? { target: "origin", above: dataset.fill }
                : false;
            dataList.datasets.push({
                label: dataset.name, //	set dataset label
                data: dataset.y, //	Set Y-axis data
                backgroundColor: colors.backgroundColor,
                borderColor: colors.borderColor,
                borderWidth: dataset.borderWidth,
                type: dataset.type,
                fill: fillColorStat,
                hidden: dataset.hidden !== undefined ? dataset.hidden : false,
            });
        }
    });
    //	console.log(dataList);
    return dataList;
};
export const getSettings = (options) => {
    const defaults = {
        zoom: false,
        download: false,
        zoomType: "wheel",
        interactionMode: "point",
    };
    return extend(defaults, options);
};
export const getOptions = (options, titleLoader, subtitleLoader, xAxisLoader, yAxisLoader) => {
    const Title = titleLoader?.getConfig();
    const Subtitle = subtitleLoader?.getConfig();
    const AxisX = xAxisLoader?.getConfig();
    const AxisY = yAxisLoader?.getConfig();
    const chartSettings = getSettings(options);
    const myChartOptions = {
        responsive: true,
        plugins: {
            zoom: {
                limits: {
                    x: { min: "original", max: "original" },
                    y: { min: "original", max: "original" },
                },
                zoom: {
                    wheel: {
                        enabled: chartSettings.zoom && chartSettings.zoomType === "wheel",
                    },
                    drag: {
                        enabled: chartSettings.zoom && chartSettings.zoomType === "drag",
                        //	sensitivity:0.5,
                        borderColor: "rgb(54, 162, 235)",
                        borderWidth: 2,
                        backgroundColor: "rgba(54, 162, 235, 0.3)",
                    },
                },
                pan: {
                    enabled: chartSettings.zoom,
                    modifierKey: chartSettings.zoom && chartSettings.zoomType === "drag"
                        ? "ctrl"
                        : undefined,
                },
            },
            title: {
                display: Title?.display ?? false,
                text: Title?.text ?? "",
                color: Title?.color ?? "black",
                position: Title?.position ?? "top",
                align: "start", // start/center/end
                padding: {
                    top: 0,
                    bottom: 10,
                },
                font: {
                    size: 20,
                    weight: "normal",
                },
            },
            subtitle: {
                display: Subtitle?.display ?? false,
                text: Subtitle?.text ?? "",
                color: Subtitle?.color ?? "#4f4f4f",
                position: Subtitle?.position ?? "top",
                align: Subtitle?.align, // start/center/end
                padding: {
                    top: 0,
                    bottom: 10,
                },
                font: {
                    size: 13,
                    weight: "normal",
                },
            },
            tooltip: {
                callbacks: {
                /*title: (tooltipItems) => {
                    return `Test: ${tooltipItems[0].label}`;
                },
                label: (tooltipItem) => {
                    console.log(tooltipItem);
                },
                footer: (tooltipItems) => {
                    console.log(tooltipItems);
                }*/
                },
            },
        },
        interaction: {
            mode: chartSettings.interactionMode,
        },
        scales: {
            x: {
                display: true,
                type: "category",
                // type: 'time',
                title: {
                    display: AxisX?.display,
                    text: AxisX?.text,
                    color: AxisX?.color,
                    align: AxisX?.align, // start/center/end
                    padding: { top: 10, bottom: 0 },
                },
                ticks: {
                    callback: function (value) {
                        return ticksFormatter(this, value);
                    },
                },
            },
            y: {
                display: true,
                title: {
                    display: AxisY?.display,
                    text: AxisY?.text,
                    color: AxisY?.color,
                    align: AxisY?.align, // start/center/end
                    // padding: {top: 0, left: 0, right: 0, bottom: 0}
                },
                // ticks: {/*callback: function (value, index, ticks) {return '$' + value;}*/}
                ticks: {},
            },
        },
    };
    /* Update Y zoom limits */
    if (chartSettings.zoom &&
        myChartOptions.plugins?.zoom?.limits?.y !== undefined &&
        chartSettings.yMin !== undefined &&
        chartSettings.yMax !== undefined &&
        typeof chartSettings.yMin === "number" &&
        typeof chartSettings.yMax === "number") {
        const yAdd = (chartSettings.yMax - chartSettings.yMin) / 10;
        myChartOptions.plugins.zoom.limits.y = {
            min: chartSettings.yMin - yAdd,
            max: chartSettings.yMax + yAdd,
        };
    }
    //	console.warn('myChartOptions', myChartOptions);
    return myChartOptions;
};
export const getConfig = (options, datasets, titleLoader, subtitleLoader, xAxisLoader, yAxisLoader) => {
    const dataList = getDataList(datasets);
    return {
        type: dataList.datasets[0].type,
        data: dataList,
        options: getOptions(options, titleLoader, subtitleLoader, xAxisLoader, yAxisLoader),
    };
};
//# sourceMappingURL=ChartLoader.js.map